/**
 * SELECT 
 *      UPPER(lusAbbreviation)+ ' =', 
 *      CHAR(39) + UPPER(lusName) + CHAR(39) + ',' 
 *  FROM 
 *      lutState_lus WHERE lusFK_lucID = 3 
 *  ORDER BY 
 *      lusName;
 */
export enum USStates {
    AL = 'ALABAMA',
    AK = 'ALASKA',
    AS = 'AMERICAN SAMOA',
    AZ = 'ARIZONA',
    AR = 'ARKANSAS',
    CA = 'CALIFORNIA',
    CO = 'COLORADO',
    CT = 'CONNECTICUT',
    DE = 'DELAWARE',
    DC = 'DISTRICT OF COLUMBIA',
    FM = 'FEDERATED STATES OF MICRONESIA',
    FL = 'FLORIDA',
    GA = 'GEORGIA',
    GU = 'GUAM',
    HI = 'HAWAII',
    ID = 'IDAHO',
    IL = 'ILLINOIS',
    IN = 'INDIANA',
    IA = 'IOWA',
    KS = 'KANSAS',
    KY = 'KENTUCKY',
    LA = 'LOUISIANA',
    ME = 'MAINE',
    MH = 'MARSHALL ISLANDS',
    MD = 'MARYLAND',
    MA = 'MASSACHUSETTS',
    MI = 'MICHIGAN',
    MN = 'MINNESOTA',
    MS = 'MISSISSIPPI',
    MO = 'MISSOURI',
    MT = 'MONTANA',
    NE = 'NEBRASKA',
    NV = 'NEVADA',
    NH = 'NEW HAMPSHIRE',
    NJ = 'NEW JERSEY',
    NM = 'NEW MEXICO',
    NY = 'NEW YORK',
    NC = 'NORTH CAROLINA',
    ND = 'NORTH DAKOTA',
    MP = 'NORTHERN MARIANA ISLANDS',
    OH = 'OHIO',
    OK = 'OKLAHOMA',
    OR = 'OREGON',
    PW = 'PALAU',
    PA = 'PENNSYLVANIA',
    PR = 'PUERTO RICO',
    RI = 'RHODE ISLAND',
    SC = 'SOUTH CAROLINA',
    SD = 'SOUTH DAKOTA',
    TN = 'TENNESSEE',
    TX = 'TEXAS',
    UT = 'UTAH',
    VT = 'VERMONT',
    VI = 'VIRGIN ISLANDS',
    VA = 'VIRGINIA',
    WA = 'WASHINGTON',
    WV = 'WEST VIRGINIA',
    WI = 'WISCONSIN',
    WY = 'WYOMING',
}

export enum PayrollTaxStates {
    AL = 'Alabama',
    AK = 'Alaska',
    AZ = 'Arizona',
    AR = 'Arkansas',
    CA = 'California',
    CO = 'Colorado',
    CT = 'Connecticut',
    DE = 'Delaware',
    FL = 'Florida',
    GA = 'Georgia',
    HI = 'Hawaii',
    ID = 'Idaho',
    IL = 'Illinois',
    IN = 'Indiana',
    IA = 'Iowa',
    KS = 'Kansas',
    KY = 'Kentucky',
    LA = 'Louisiana',
    ME = 'Maine',
    MD = 'Maryland',
    MA = 'Massachusetts',
    MI = 'Michigan',
    MN = 'Minnesota',
    MS = 'Mississippi',
    MO = 'Missouri',
    MT = 'Montana',
    NE = 'Nebraska',
    NV = 'Nevada',
    NH = 'New Hampshire',
    NJ = 'New Jersey',
    NM = 'New Mexico',
    NY = 'New York',
    NC = 'North Carolina',
    ND = 'North Dakota',
    OH = 'Ohio',
    OK = 'Oklahoma',
    OR = 'Oregon',
    PA = 'Pennsylvania',
    RI = 'Rhode Island',
    SC = 'South Carolina',
    SD = 'South Dakota',
    TN = 'Tennessee',
    TX = 'Texas',
    UT = 'Utah',
    VT = 'Vermont',
    VA = 'Virginia',
    WA = 'Washington',
    WV = 'West Virginia',
    WI = 'Wisconsin',
    WY = 'Wyoming',
}